import { useResponsiveSectionMargin } from 'design-system/layout';

import { Spacer } from './Spacer';

export const SectionSpacer: React.FC = () => {
  const height = useResponsiveSectionMargin();

  return <Spacer height={height} />;
};
